export default "__VITE_ASSET__c4276204__"